module.exports = __webpack_public_path__ + "a77c9a1d.svg";